import LoadActivity from './LoadActivity';

export default LoadActivity;
